import { env } from 'src/config/env';
import { logger } from 'src/logger/logger';
import {
    getOrCreateSessionId,
    rotateSessionId,
} from 'src/logger/session-id';
import { getApplicationRelease } from 'src/config/applicationRelease';
import { resetRumSessionOnLogout } from 'src/utils/cloudwatch-rum';

/**
 * Non-PII ops fields we mirror from analytics identify/update onto the logger
 * (and thus RUM session attributes + custom event payloads).
 * Never include email or other direct identifiers here.
 */
export const OPS_LOGGER_CONTEXT_KEYS = Object.freeze([
    'agency_id',
    'agency_type',
    'user_role',
    'lyt_employee',
    'jurisdiction_id',
]);

/**
 * Stamp session + deploy context on the logger as soon as the app boots.
 * Call after CloudWatch RUM init so session attributes can attach immediately.
 */
export const initializeLoggerSession = () => {
    logger.setContext({
        session_id: getOrCreateSessionId(),
        environment: env.environment || 'unknown',
        release: getApplicationRelease(),
    });
};

/**
 * Copy allowlisted analytics properties onto logger context.
 *
 * @param {Object} properties
 */
export const syncOpsLoggerContextFromAnalytics = (properties = {}) => {
    if (!properties || typeof properties !== 'object') {
        return;
    }

    const attrs = {};
    OPS_LOGGER_CONTEXT_KEYS.forEach((key) => {
        const value = properties[key];
        if (value !== undefined && value !== null && value !== '') {
            attrs[key] = value;
        }
    });

    if (Object.keys(attrs).length === 0) {
        return;
    }

    logger.setContext(attrs);
};

/**
 * Drop user-scoped ops context on logout so logger/RUM events on the login
 * page are not attributed to the previous user.
 */
export const clearOpsLoggerContextOnLogout = () => {
    logger.removeContext([...OPS_LOGGER_CONTEXT_KEYS]);
    resetRumSessionOnLogout();
    logger.setContext({
        session_id: rotateSessionId(),
    });
};
